import { isPresent } from "@/lib/utils"
import { resolveHomeTarget } from "@/router/home"

export const DEFAULT_TABBAR_LINKS = [
  {
    text: "Home",
    icon: "home",
    path: "/"
  },
  {
    text: "Schedule",
    icon: "calendar_today",
    path: "/me/schedule"
  },
  {
    text: "You",
    icon: "person",
    path: "/me/my-content"
  }
]

export const isTabbarShown = ({
  currentPage,
  isVideoFullscreen,
  isDesktop
}) => {
  if (isVideoFullscreen) return false

  if (!currentPage) return true

  if (!currentPage.show_navigation) return false
  if (isDesktop) return currentPage.show_sidebar_navigation

  // Hide tabbar on workout pages or pages with actions
  if (currentPage.type === "workout") return false
  if (currentPage.actions?.length) return false

  return currentPage.show_tabbar
}

export default {
  namespaced: true,

  state: {
    showSidebar: false
  },

  mutations: {
    toggleSidebar(state) {
      state.showSidebar = !state.showSidebar
    },

    setShowSidebar(state, showSidebar = true) {
      state.showSidebar = showSidebar
    }
  },

  getters: {
    tabbarLinks(_, __, state) {
      return isPresent(state.global) &&
        isPresent(state.global.tabbar) &&
        isPresent(state.global.tabbar.links)
        ? state.global.tabbar.links
        : DEFAULT_TABBAR_LINKS
    },

    // The actual destination for the Home link, resolved per auth state so the
    // tab navigates straight to the visitor's home instead of "/" then bouncing.
    // Stays on "/" until auth is known so a member doesn't briefly resolve to the
    // signed-out home during boot; the root guard resolves it once auth settles.
    homeTarget(_, __, state, rootGetters) {
      if (!rootGetters["auth/hasCheckedAuthentication"]) return "/"

      return resolveHomeTarget({
        isAuthenticated: rootGetters["auth/isAuthenticated"],
        homepagePath: rootGetters["auth/currentUser"]?.homepagePath,
        signedOutHomepagePath: state.global?.signed_out_homepage_path
      })
    },

    isTabbarShown(_, __, state) {
      return isTabbarShown({
        currentPage: state.pages.currentPage,
        isVideoFullscreen: state.videos.isFullscreen,
        isDesktop: state.responsive.isDesktop
      })
    }
  }
}
